module.exports = __webpack_public_path__ + "img/fecha.dcb51be0.png";